import React, { useState } from 'react';

export default function VideoFacade({
  title,
  videoId,
  provider = 'youtube',
  poster,
  caption,
  className = '',
}) {
  const [isPlaying, setIsPlaying] = useState(false);

  const embedUrl =
    provider === 'youtube'
      ? `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&rel=0`
      : `https://player.vimeo.com/video/${videoId}?autoplay=1&dnt=1`;

  const fallbackPoster =
    poster ||
    (provider === 'youtube'
      ? `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`
      : 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traefaeldning.jpg');

  return (
    <div className={`relative overflow-hidden rounded-2xl bg-black shadow-lg ${className}`}>
      {isPlaying ? (
        <div className="relative aspect-video w-full">
          <iframe
            src={embedUrl}
            title={title || 'Videopræsentation'}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full border-0"
          />
        </div>
      ) : (
        <div
          className="group relative aspect-video w-full cursor-pointer flex items-center justify-center overflow-hidden"
          onClick={() => setIsPlaying(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setIsPlaying(true);
            }
          }}
          aria-label={`Afspil video: ${title || 'Videopræsentation'}`}
        >
          <img
            src={fallbackPoster}
            alt={title || 'Videofacade'}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="eager"
            onError={(e) => {
              if (provider === 'youtube' && !e.currentTarget.src.includes('hqdefault.jpg')) {
                e.currentTarget.src = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
              }
            }}
          />
          {/* Overlay with centered play button */}
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
            <span className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-[#1b4332]/95 group-hover:bg-[#1b4332] text-white flex items-center justify-center shadow-2xl transition-transform duration-300 group-hover:scale-110 border-2 border-white/80">
              <i className="fa-solid fa-play text-xl sm:text-2xl ml-1 text-white" aria-hidden="true" />
            </span>
          </div>
        </div>
      )}

      {/* caption removed as requested */}
    </div>
  );
}
